import { FormattedMessage } from 'react-intl';

import { GridItem } from '@xing-com/grid';

import HeaderImage from '../../assets/header-image.png';
import { ProductCta } from '../product-cta/product-cta';

import {
  ProductHeaderContainer,
  StyledHeadline,
  ProductCtasWrapper,
  StyledGridContainer,
  Image,
} from './products-header.styles';

export const ProductsHeader: React.FC = () => {
  return (
    <ProductHeaderContainer variant="FullSize">
      <GridItem span={12}>
        <StyledHeadline size="large" sizeConfined="xxlarge">
          <FormattedMessage id="UPSELL_LOGGED_OUT_PAGE_HEADER_HEADLINE" />
        </StyledHeadline>
      </GridItem>
      <GridItem span={12}>
        <StyledGridContainer variant="FullSize">
          <ProductCtasWrapper span={12} spanLarge={6}>
            <ProductCta product="projobs" />
            <ProductCta product="premium" />
          </ProductCtasWrapper>
          <GridItem span={10} spanMedium={8} spanLarge={6}>
            <Image src={HeaderImage} alt="" />
          </GridItem>
        </StyledGridContainer>
      </GridItem>
    </ProductHeaderContainer>
  );
};
